export class ErrorValidator {
    dscMensaje = '';
    flgInvalid = false;

}

